import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import {mixins} from "@/mixin/publicJs";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

import createAlignPlugin from '@kangc/v-md-editor/lib/plugins/align';
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import VMdPreviewHtml from '@kangc/v-md-editor/lib/preview-html';
import '@kangc/v-md-editor/lib/style/preview-html.css';
import createHighlightLinesPlugin from '@kangc/v-md-editor/lib/plugins/highlight-lines/index';
import '@kangc/v-md-editor/lib/plugins/highlight-lines/highlight-lines.css';
// highlightjs
import hljs from 'highlight.js';

const app = createApp(App)

app.use(ElementPlus, {
	locale: zhCn,
})

app.mixin(mixins)
app.use(store)
app.use(router)

const debounce = (fn, delay) => {
	let timer = null;
	return function () {
		let context = this;
		let args = arguments;
		clearTimeout(timer);
		timer = setTimeout(function () {
			fn.apply(context, args);
		}, delay);
	}
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
	constructor(callback) {
		callback = debounce(callback, 16);
		super(callback);
	}
}

VueMarkdownEditor.use(vuepressTheme, {
	Prism,
	config: {
		toc: {
			includeLevel: [1,2,3,4],
		},
	},
});
VueMarkdownEditor.use(createAlignPlugin());
VueMarkdownEditor.use(createHighlightLinesPlugin());
VMdPreview.use(githubTheme, {
	Hljs: hljs,
});

app.use(VueMarkdownEditor);
app.use(VMdPreview);
app.use(VMdPreviewHtml);

app.mount('#app')
